import { create } from 'zustand';
import * as newsService from '../api/newsService';
import logger from '../utils/logger';

// ponytail: Zustand store replacing the NewsContext boilerplate
export const useNewsStore = create((set, get) => ({
  newsItems: [],
  loading: false,
  error: null,
  initialized: false,

  fetchNewsItems: async (params = {}) => {
    try {
      set({ loading: true });
      const response = await newsService.getAllNews(params);
      set({ newsItems: response.data.news || [], error: null, initialized: true });
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        set({ newsItems: [], error: null, initialized: true });
        return;
      }
      logger.error('Error fetching news items:', err);
      set({ error: err.response?.data?.message || 'Failed to load news' });
    } finally {
      set({ loading: false });
    }
  },

  addNewsItem: async (formData) => {
    try {
      const response = await newsService.createNews(formData);
      set((state) => ({ newsItems: [response.data.news, ...state.newsItems] }));
      return { success: true, data: response.data.news };
    } catch (err) {
      logger.error('Error adding news item:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to create news' };
    }
  },

  updateNewsItem: async (id, data) => {
    try {
      const response = await newsService.updateNews(id, data);
      set((state) => ({
        newsItems: state.newsItems.map((item) => (item._id === id ? response.data.news : item)),
      }));
      return { success: true, data: response.data.news };
    } catch (err) {
      logger.error('Error updating news item:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to update news' };
    }
  },

  deleteNewsItem: async (id) => {
    try {
      await newsService.deleteNews(id);
      set((state) => ({ newsItems: state.newsItems.filter((item) => item._id !== id) }));
      return { success: true };
    } catch (err) {
      logger.error('Error deleting news item:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to delete news' };
    }
  },

  toggleNewsStatus: async (id) => {
    try {
      const response = await newsService.toggleNewsStatus(id);
      set((state) => ({
        newsItems: state.newsItems.map((item) => (item._id === id ? response.data.news : item)),
      }));
      return { success: true, data: response.data.news };
    } catch (err) {
      logger.error('Error toggling news status:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to toggle status' };
    }
  },

  bulkDelete: async (ids) => {
    try {
      await newsService.bulkDeleteNews(ids);
      set((state) => ({ newsItems: state.newsItems.filter((item) => !ids.includes(item._id)) }));
      return { success: true };
    } catch (err) {
      logger.error('Error bulk deleting news items:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to delete news items' };
    }
  },
}));
